module.exports = __webpack_public_path__ + "img/order-cancelled.1ff7eab3.png";